import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from '@emotion/styled'
import { Box, Link } from '@mui/material'
import PropTypes from 'prop-types'

export function AppMenuItem(props) {
  const { indent, ...otherProps } = props
  const location = useLocation()
  const gunMetal = '#253140'

  const StyledLink = styled(Link)({
    color: 'white',
    fontSize: '16px',
    padding: `20px 32px 20px ${32 + indent * 20}px`,
    borderTop: `1px solid ${gunMetal}`,
    borderLeft: '10px solid transparent',
    margin: 0,
    transition: '0.5s',
    ':hover': {
      borderBottom: 'none',
      cursor: 'pointer',
      color: '#A4AAFF'
    },
    '&.active': {
      backgroundColor: 'white',
      color: gunMetal,
      borderLeft: `10px solid #A4AAFF`
    }
  })

  return (
    <StyledLink
      className={location.pathname.includes(props.to) ? 'active' : ''}
      {...otherProps}
    />
  )
}

AppMenuItem.propTypes = {
  indent: PropTypes.number,
  to: PropTypes.string.isRequired,
  otherProps: PropTypes.node,
  variant: PropTypes.string
}

AppMenuItem.defaultProps = {
  indent: 0
}

export function AppMenuAccordion(props) {
  const { title, children, ...otherProps } = props
  const [isActive, setIsActive] = useState(false)

  const StyledLink = styled(Link)({
    color: 'white',
    fontSize: '16px',
    padding: `20px 32px`,
    borderTop: '1px solid #253140',
    borderLeft: '10px solid transparent',
    margin: 0,
    transition: '0.5s',
    ':hover': {
      borderBottom: 'none',
      cursor: 'pointer',
      color: '#A4AAFF'
    },
    '&.active': {
      backgroundColor: 'white',
      color: '#253140',
      borderLeft: `10px solid #A4AAFF`
    }
  })

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <StyledLink
        onClick={() => setIsActive(!isActive)}
        className={location.pathname.includes(props.to) ? 'active' : ''}
        {...otherProps}
      >
        <div id={title}>{title}</div>
      </StyledLink>
      {isActive && children}
    </Box>
  )
}

AppMenuAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  children: PropTypes.node
}
